import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'contract',
    props: true,
    path: '/contract/:id',
    component: () => LazyLoadView(import(/* webpackChunkName: "contract" */ '@/views/Contract/Mutate/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'contract-data',
    props: true,
    path: '/contract/:id/data',
    component: () => LazyLoadView(import(/* webpackChunkName: "contract-data" */ '@/views/Contract/Data.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'custom-contract-create',
    props: route => ({ contact: route.query.contact }),
    path: '/contract/custom/create',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "custom-contract-create" */ '@/views/Contract/Custom/Create.vue')),
    beforeEnter: isAuthenticated,
  },
]
